export const name = 'scan';

export const Scan = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(2.5, 3)">
      <path
        d="M7.00863 2.61572H2.87988V6.73885"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinejoin="round"
      />
      <path
        d="M2.87988 11.2612V15.3844H7.00863"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinejoin="round"
      />
      <path
        d="M15.6202 6.73885V2.61572H11.4971"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinejoin="round"
      />
      <path
        d="M11.4971 15.3844H15.6202V11.2612"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinejoin="round"
      />
      <rect x="1.75" y="8.4375" width="15" height="1.125" fill="currentColor" />
    </g>
  </svg>
);
